module.exports = __webpack_public_path__ + "img/بروشورa5.24653290.jpg";